import React, { Fragment, useState } from 'react';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UrlEnum } from '../../../../shared';
import eventEmitter from '../../../../shared/eventEmitter';
import { EditProgramRequestModal } from '../ProgramRequestModal';
import { RequestMetadataPanel } from './RequestMetadataPanel';
import { RequestDetailsRouter } from './RequestDetailsRouter';

// Layout (column flex inside div.request-main):
//   [back bar]         ← institution only
//   [request-columns]  ← .request-metadata | .request-type-details | {children}
//   [footer]           ← admin action buttons spanning all 3 columns
export const RequestDetailsPanel = ({
    requestDetails,
    requestLogs,
    showBackButton,
    children,
    footer,
}) => {
    const [isEditOpen, setIsEditOpen] = useState(false);

    return (
        <Fragment>
            <div className="request-main">
                {showBackButton && (
                    <div className="request-back-bar">
                        <a href={UrlEnum.INSTITUTION_SEARCH_ACADEMIC_PROGRAM_REQUESTS}>
                            <FontAwesomeIcon icon={faArrowLeft} /> Back to all program
                            requests
                        </a>
                    </div>
                )}
                <div className="request-columns">
                    <RequestMetadataPanel
                        details={requestDetails}
                        onEditClick={() => setIsEditOpen(true)}
                    />
                    <RequestDetailsRouter
                        requestDetails={requestDetails}
                        requestLogs={requestLogs}
                    />
                    {children}
                </div>
                {footer}
            </div>
            <EditProgramRequestModal
                isOpen={isEditOpen}
                toggle={() => setIsEditOpen(false)}
                requestDetails={requestDetails}
                institutionOptions={[
                    {
                        value: requestDetails?.institutionId,
                        label: requestDetails?.institutionName,
                    },
                ]}
                onSuccess={() => {
                    eventEmitter.emit('updateSARData');
                }}
            />
        </Fragment>
    );
};
